module.exports = __webpack_public_path__ + "static/media/F-AvvMZaQAArDfA.09fd32b7.webp";